<template>
    <div id="nav" :data-theme="userTheme">
        <div class="left">
            <a class="logo" href="">
                <img src="@/assets/logo1.png" alt="">
            </a>
            <nav class="nav-menu">
                <!--    现货交易    -->
                <div class="nav-menu-item" @click="$router.push('/spot')">
                    <span class="menu-text">{{ $t('nav.t1') }}</span>
                </div>
                <!--    现货交易    -->
                <div class="nav-menu-item" @click="$router.push('/quotes')">
                    <span class="menu-text">{{ $t('nav.as1') }}</span>
                </div>
                <!--    衍生品    -->
                <div class="nav-menu-item">
                    <span class="menu-text">{{ $t('nav.t2') }}</span>
                    <div class="submenu">
                        <div class="submenu-item" @click="$router.push('/futures')">
                            <img :src="require(`@/assets/images/navbar/hy-${userTheme}.png`)" alt="">
                            <span>{{ $t('nav.t9') }}</span>
                        </div>
<!--                        $router.push('/flashOption')-->
                        <div class="submenu-item" @click="$notification.info($t('nav.as2'))">
                            <img :src="require(`@/assets/images/navbar/sf-${userTheme}.png`)" alt="">
                            <span>{{ $t('nav.t51') }}</span>
                        </div>
<!--                        $router.push('/copyTraders')-->
                        <div class="submenu-item" @click="$notification.info($t('nav.as2'))">
                            <img :src="require(`@/assets/images/navbar/hygd-${userTheme}.png`)" alt="">
                            <span>{{ $t('nav.t50') }}</span>
                        </div>
                    </div>
                </div>
                <!--   资管理财   -->
                <div class="nav-menu-item" style="display: none;">
                    <span class="menu-text" @click="$router.push('/investment')">暴富理财</span>
                    <div class="submenu">
                        <div class="submenu-item" @click="$router.push('/easyEarn')">
                            <img :src="require(`@/assets/images/navbar/hbb-${userTheme}.png`)" alt="">
                            <span>质押生息</span>
                        </div>
                        <div class="submenu-item" @click="$router.push('/term')">
                            <img :src="require(`@/assets/images/navbar/bflc-${userTheme}.png`)" alt="">
                            <span>暴富理财</span>
                        </div>
<!--                        <div class="submenu-item" @click="$router.push('/pledge')">-->
<!--                            <img :src="require(`@/assets/images/navbar/ptzy-${userTheme}.png`)" alt="">-->
<!--                            <span>平台币质押理财</span>-->
<!--                        </div>-->
<!--                        <div class="submenu-item" @click="$router.push('/fund')">-->
<!--                            <img :src="require(`@/assets/images/navbar/gfjj-${userTheme}.png`)" alt="">-->
<!--                            <span>共富基金</span>-->
<!--                        </div>-->
                    </div>
                </div>
                <!--    智富乐园    -->
                <div class="nav-menu-item"  style="display: none;">
                    <span class="menu-text">福利活动</span>
                    <div class="submenu">
                        <div class="submenu-item" @click="$router.push('/onePurchase')">
                            <img :src="require(`@/assets/images/navbar/1yg-${userTheme}.png`)" alt="">
                            <span>一元购</span>
                        </div>
<!--                        <div class="submenu-item" @click="$router.push('/flashOption')">-->
<!--                            <img :src="require(`@/assets/images/navbar/sf-${userTheme}.png`)" alt="">-->
<!--                            <span>闪富 (闪期权)</span>-->
<!--                        </div>-->
<!--                        <div class="submenu-item" @click="$router.push('/volatilityOption')">-->
<!--                            <img :src="require(`@/assets/images/navbar/kf-${userTheme}.png`)" alt="">-->
<!--                            <span>快富 (波动率期权)</span>-->
<!--                        </div>-->
                        <div class="submenu-item" @click="$router.push('/BindBox')">
                            <img :src="require(`@/assets/images/navbar/bfmh-${userTheme}.png`)" alt="">
                            <span>暴富盲盒</span>
                        </div>
                    </div>
                </div>
                <!--    帮助中心    -->
                <div class="nav-menu-item" @click="$router.push('/help')">
                    <span class="menu-text">{{ $t('nav.t5') }}</span>
                </div>
            </nav>
        </div>
        <div class="right">
            <template v-if="!isLogin">
                <a-button class="login button" @click="$router.push('/login')">{{ $t('login.t20') }}</a-button>
                <a-button class="enroll button" @click="$router.push('/register')">{{ $t('login.t24') }}</a-button>
            </template>
            <div class="imgBox" v-if="false">
                <icon-search/>
            </div>
            <template v-if="isLogin">
                <div class="imgBox" @click="$router.push('/HomeView/assets')">
                    <icon-archive/>
                </div>
                <div class="imgBox">
                    <icon-file/>
                    <div class="menuPopup">
                        <p class="font-16 _title color-black font-bold">{{ $t('nav.as3') }}</p>
                        <div class="popBox">
                            <div class="row" @click="$router.push({path:'/HomeView/assets',query:{menu:6,account:1}})">
                                <span class="font-14 color-black">{{ $t('nav.t1') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="$router.push({path:'/HomeView/assets',query:{menu:6,account:2}})">
                                <span class="font-14 color-black">{{ $t('nav.t9') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="$router.push({path:'/HomeView/assets',query:{menu:6,account:3}})">
                                <span class="font-14 color-black">{{ $t('nav.t51') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="$router.push({path:'/HomeView/assets',query:{menu:6,account:4}})">
                                <span class="font-14 color-black">{{ $t('nav.as4') }}</span>
                                <icon-right size="16"/>
                            </div>
<!--                            <div class="row">-->
<!--                                <span class="font-14 color-black">闪兑交易记录</span>-->
<!--                                <icon-right size="16"/>-->
<!--                            </div>-->
<!--                            <div class="row">-->
<!--                                <span class="font-14 color-black">理财交易记录</span>-->
<!--                                <icon-right size="16"/>-->
<!--                            </div>-->
<!--                            <div class="row">-->
<!--                                <span class="font-14 color-black">质押借贷记录</span>-->
<!--                                <icon-right size="16"/>-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>
            </template>
            <div class="imgBox">
                <icon-notification/>
            </div>
            <div class="imgBox">
                <icon-menu v-if="!isLogin"/>
                <img v-else class="userImg" @click="$router.push('/HomeView/personal')" src="@/assets/images/avatar.png"
                     alt="">
                <div class="menuPopup">
                    <div class="cell">
                        <a-tooltip background-color="var(--tooltip-bg)" :content="$t('nav.as6')">
                            <div class="item" @click="languagePop = true">
                                <icon-left size="22" class="mr-10"/>
                                <span>{{ $t('nav.as5') }}</span>
                            </div>
                        </a-tooltip>
                        <a-tooltip background-color="var(--tooltip-bg)" :content="$t('nav.as7')">
                            <div class="item" @click="languagePop = true">
                                <icon-common size="22" class="mr-10"/>
                                <span>USD</span>
                            </div>
                        </a-tooltip>
                        <a-tooltip background-color="var(--tooltip-bg)" :content="$t('nav.as8')">
                            <div class="item" @click="toggleUserTheme">
                                <icon-sun-fill size="22"/>
                            </div>
                        </a-tooltip>
                    </div>
                    <template v-if="!isLogin">
                        <div class="codeBox">
                            <div class="codeImage">
                                <!--<img :src="config['dpage']" alt="">-->
                                <img src="@/assets/down.png" alt="">
                            </div>
                            <span>{{ $t('nav.as9') }}</span>
                        </div>
                        <a-button class="button" @click="openurl(config['download'])">
                            <icon-download class="mr-10" size="20"/>
                            {{ $t('nav.as10') }}
                        </a-button>
                    </template>
                    <template v-else>
                        <div class="popBox">
                            <div class="info">
                                <div class="top">
                                    <img src="@/assets/images/avatar.png" alt="">
                                    <div class="right">
                                        <p class="font-16 color-black font-bold">{{ userNickname }}</p>
                                        <p class="font-13 color-gray">UID:{{ userId }}
                                            <icon-copy/>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <span class="font-14 color-black">{{ $t('nav.as11') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row">
                                <span class="font-14 color-black">{{ $t('nav.as12') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <!--              <div class="row">-->
                            <!--                <span class="font-14 color-black">卡卷</span>-->
                            <!--                <icon-right size="16"/>-->
                            <!--              </div>-->
                            <!--              <div class="row">-->
                            <!--                <span class="font-14 color-black">地址簿</span>-->
                            <!--                <icon-right size="16"/>-->
                            <!--              </div>-->
                            <!--              <div class="row">-->
                            <!--                <span class="font-14 color-black">API密钥</span>-->
                            <!--                <icon-right size="16"/>-->
                            <!--              </div>-->
                            <div class="row" @click="$router.push('/HomeView/assets')">
                                <span class="font-14 color-black">{{ $t('nav.as13') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="$router.push('/HomeView/personal')">
                                <span class="font-14 color-black">{{ $t('nav.as14') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="$router.push('/HomeView/personal')">
                                <span class="font-14 color-black">{{ $t('nav.as15') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <a-button class="quit" @click="loginOut">{{ $t('nav.as16') }}</a-button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!--  弹窗-->
        <a-modal :closable="false"
                 align-center
                 width="840px"
                 mask-closable
                 body-class="modelBox"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 :hide-title="false"
                 :footer="false"
                 :visible="languagePop">
            <div class="model">
                <a-tabs>
                    <template #extra>
                        <icon-close class="cursor close" size="20" @click="languagePop = false"/>
                    </template>
                    <a-tab-pane key="1" :title="$t('nav.as6')">
                        <div class="list"> <!--active-->
                            <div class="item" :class="langIndex == index ? '' : '' " v-for="(item,index) in lang"
                                 :key="index" @click="setLang(item)">
                                <span>{{ item.label }}</span>
                            </div>
                        </div>
                    </a-tab-pane>
                    <!--<a-tab-pane key="2" :title="$t('nav.as7')">
                        <div class="list">
                            <div class="item" :class="langIndex == index ? '' : '' "
                                 v-for="(item,index) in exchange"
                                 :key="index">
                                <span>{{ item }}</span>
                            </div>
                        </div>
                    </a-tab-pane>-->
                </a-tabs>
            </div>
        </a-modal>
    </div>
</template>

<script>
import WOW from "wow.js";
import config from "@/common/api/config";
import {
    mapState,
    mapGetters,
    mapMutations
} from 'vuex';


export default {
    name: 'pageNav',
    props: {
        menuShow: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            downpop: false,
            languagePop: false,
            coinPop: false,
            langIndex: 0,
            propertyOption: [
                {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.aa1')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.aqs1')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.aqs2')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.aqs3')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.aqs4')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.aqs5')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.aqs6')
                }],
            property: false,
            order: false,
            orderList: [
                {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.a1')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.a2')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text:this.$t('nav.a3') 
                },
            ],
            usOption: [
                {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.a4') 
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.as12')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.as15')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.aa2')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text:this.$t('nav.aa4') 
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('nav.as16')
                },
            ],
            uspop: false,
            logType: true,
            langText: this.$t('nav.t9'),
            lang: [],
            exchange: ['USD - $', 'CNY - ￥', 'JPY - Ұ', 'TWD - NT$']
        }
    },
    mounted() {
        var wow = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
        });
        wow.init();
        this.getLang()
        // this.logType = this.isLogin
    },
    computed: {
        ...mapGetters(['isLogin', 'userId', 'userTheme', 'userNickname']),
        ...mapState(['config', 'userinfo']),
    },
    methods: {
        loginOut() {
            this.$store.commit('userLogin', false);
            this.$router.push('/login');
        },
        toggleUserTheme() {
            switch (this.userTheme) {
                case 'light':
                    this.$store.commit('updateTheme', 'dark');
                    break;
                case 'dark':
                    this.$store.commit('updateTheme', 'light');
                    break;
            }
            console.log(this.userTheme);
        },
        routerLink(subItem) {
            this.$router.push(subItem.pageUrl)
        },
        routerPage(menu) {
            this.$router.push(menu.href)
        },
        toSport() {
            this.$router.push("/HomeView/spot")
        },
		openurl(url) {
		    window.open(url);
		},
        toDownload() {
            this.$router.push("/HomeView/appDownload")
        },
        toAssets() {
            this.$router.push("/HomeView/assets")
        },
        toPersonal() {
            this.$router.push("/HomeView/personal")
        },
        toOrder() {
            this.$router.push("/HomeView/order")
        },
        usChange(index) {
            console.log(index);
            if (index == 5) {
                this.logType = false;
            }
        },
        getLang() {
			
            this.lang = [
                //{label: '中文', value: 'zh_CN'},
                {label: 'English', value: 'en'},
               // {label: '中文繁体', value: 'zh-Hant'},
                //{label: 'Japanese', value: 'ja'},
                //{label: 'Korean', value: 'ko'},
            ]
			
			
            let lang = this.$util.getCache('lang')
			
            if (!lang) {
                lang = config.default_lang
            }
			
            for (const langKey in this.lang) {
                if (this.lang[langKey].value == lang) {
                    this.langText = this.lang[langKey].label
                }
            }
            //console.log(this.$util.getCache('lang'))
        },
        setLang(item) {
			//langIndex
            this.$util.setCache('lang', item.value)
            this.langText = item.label
            window.location.reload();
        }
    }
}
</script>

<style scoped lang="scss">
@import "./pagenav.scss";
</style>
  